<template>
  <div>
    <h1 class="display-4">{{ h1 }}</h1>
    <hr />

    <b-form>
      <b-form-group>
        <label for="nom_ville" class="required">Ville</label>
        <b-form-input id="nom_ville" name="nom_ville" placeholder="Nom de la ville" v-model="name" data-vv-as="Ville" v-validate="'required'"></b-form-input>
        <div v-show="errors.has('nom_ville')" class="alert alert-danger mt-3">{{ errors.first('nom_ville') }}</div>
      </b-form-group>
      <b-btn type="submit" variant="primary" @click.prevent="edit">{{ button }}</b-btn>
      <router-link to="/cities/list">
        <a class="btn btn-large btn-link">Revenir à la page précédente</a>
      </router-link>
    </b-form>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
  data () {
    return {
      button: '',
      h1: '',
      name: ''
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain']),
    id () {
      return this.$route.params.id
    }
  },
  methods: {
    edit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.id) {
            this.$http.post(this.domain + '/api/cities?access_token=' + this.access_token, { name: this.name }, { emulateJSON: true }).then((response) => {
              response.json().then((data) => {
                if (response.status === 200 && response.ok) {
                  this.$root.$bvToast.toast('La ville a bien été ajoutée', {
                    title: 'Ville ajoutée',
                    autoHideDelay: 3000,
                    append: false,
                    variant: 'success'
                  })
                  this.$router.push('/cities/list')
                }
              })
            }, (response) => {

            })
          } else {
            this.$http.post(this.domain + '/api/cities/' + this.id + '/replace?access_token=' + this.access_token, { name: this.name }, { emulateJSON: true }).then((response) => {
              response.json().then((data) => {
                if (response.status === 200 && response.ok) {
                  this.$root.$bvToast.toast('La ville a bien été modifiée', {
                    title: 'Ville modifiée',
                    autoHideDelay: 3000,
                    append: false,
                    variant: 'success'
                  })
                  this.$router.push('/cities/list')
                }
              })
            }, (response) => {

            })
          }
        }
      })
    }
  },
  mounted () {
    document.getElementById('nom_ville').focus()
    if (this.id) {
      this.$http.get(this.domain + '/api/cities/' + this.id + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.name = data.name
        })
      }, (response) => {

      })
      this.button = 'Editer'
      this.h1 = 'Editer une ville'
    } else {
      this.button = 'Valider'
      this.h1 = 'Ajouter une ville'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cities/Edit.vue